import { logger } from '@vista-digital/occ-domain';
import { defaultQuickNavigatorDropdownSelectionsState } from '../types/state';
import { QuickNavigatorActionType as ActionType } from './action-type';
import {
    defaultQuickNavigatorDisplayText
} from '@vista-digital/occ-ui/src/lib/components/quick-navigator/types/display-text'
export const quickNavigatorActionReducer = (state, action) => {
    switch (action.type) {
        case ActionType.SetSelectedValue: {
            const { selectedValue, dropdownType } = action;
            return Object.assign(Object.assign({}, state), { dropdownSelections: Object.assign(Object.assign({}, state.dropdownSelections), { [dropdownType]: selectedValue }), isModalError: false });
        }
        case ActionType.ResetDropdownSelections: {
            return Object.assign(Object.assign({}, state), { dropdownSelections: defaultQuickNavigatorDropdownSelectionsState, isModalError: false });
        }
        case ActionType.SetModalError: {
            return Object.assign(Object.assign({}, state), { isModalError: true });
        }
        default: {
            logger.error(`Unknown QuickNavigatorAction ${action.type}.`);
            return state;
        }
    }
};
//# sourceMappingURL=action-reducer.js.map